import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
     Grid,
     GridColumn,
     GridToolbar,
     GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import UiSelect from "../../../_uiComponents/common/form/UiSelectDefault";
import UiDateRangePicker from "../../../_uiMocks/_uiComponents/UiDateRangePicker";
import DehazeIcon from "@mui/icons-material/Dehaze";
import {
     Chart,
     ChartTitle,
     ChartLegend,
     ChartArea,
     ChartTooltip,
     ChartSeries,
     ChartSeriesItem,
     ChartSeriesLabels,
} from "@progress/kendo-react-charts";
import UiSlider from "../../../_uiComponents/common/UiSlider";
import { timeFormatUtcToLocal } from "../../../../_helpers/support.services";
import { dashBoardGetAreaManagersLeaguesRankSummaryRequest } from "../../../../_redux/_actions";
import { InnerLoader } from "../../../_uiComponents/common/UiLoadingSpinner";

export default function CarouselAbuDhabi(props) {
     const [areaId, setAreaId] = useState("11");
     const actionDispatch = useDispatch();

     const { leagueSummary, areaList } = useSelector((state) => {
          return {
               leagueSummary:state.dashboard.leagueSummary,
               areaList: state.dashboard.areaList,
          };
     });

     useEffect(() => {

          // actionDispatch(dashBoardGetAreaManagersLeaguesRankSummaryRequest({
          //      areaId:areaId
          // }))
     },[areaId]);

     const incentiveData = [
          {
               id: 1,
               items: [
                    {
                         rank: 1,
                         team: 'Parks Motherwell',
                         score: 176,
                    },
                    {
                         rank: 2,
                         team: 'Parks Motherwell',
                         score: 176,
                    },
                    {
                         rank: 2,
                         team: 'Parks Motherwell',
                         score: 176,
                    },
                    {
                         rank: 2,
                         team: 'Parks Motherwell',
                         score: 176,
                    }
               ]

          },
          {
               id: 2,
               items: [
                    {
                         rank: 1,
                         team: 'Parks Motherwell',
                         score: 176,
                    },
                    {
                         rank: 2,
                         team: 'Parks Motherwell',
                         score: 176,
                    }
               ]
          },


     ]

     return (
          <div>
               <div className="sba-campaign-carousel-card">
                    {/* <InnerLoader/>                 */}
                    <div className="sba-campaign-carousel-card__top">
                         <h3>Abu Dhabi Incentive</h3>
                         <div className="sba-chart-top-select-col">
                              <UiSelect
                                   options={[
                                        {
                                             value: "0",
                                             label: "All",
                                        },
                                        ...areaList.map(function (item) {
                                             return {
                                                  label: item.area,
                                                  value: item.area,
                                             };
                                        }),
                                   ]}
                                   label="Area"
                                   value={areaId}
                                   defaultValue={0}
                                   handleChange={(value) => {
                                        setAreaId(value);
                                   }}
                              />
                              {/* <UiSelect
                                   options={props.jobRolesOptions}
                                   label="Job Role"
                                   handleChange={(value) => {
                                        getData(startDate, endDate, value);
                                        setJobRoleId(value);
                                   }}
                              /> */}
                         </div>
                         {/* <div className="sba-chart-top-range-picker">
                              <UiDateRangePicker
                                   onChange={(value) => {
                                        if (value[0] && value[1]) {
                                             const startDate =
                                                  timeFormatUtcToLocal(
                                                       value[0],
                                                  );
                                             const endDate =
                                                  timeFormatUtcToLocal(
                                                       value[1],
                                                  );
                                             setStartDate(startDate);
                                             setEndDate(endDate);

                                             getData(
                                                  startDate,
                                                  endDate,
                                                  jobRoleId,
                                             );
                                        } else {
                                             if (!value[0] && !value[1]) {
                                                  setStartDate(null);
                                                  setEndDate(null);
                                                  getData(
                                                       null,
                                                       null,
                                                       jobRoleId,
                                                  );
                                             }
                                        }
                                   }}
                              />
                         </div> */}
                    </div>
                    <div className="sba-campaign-carousel-card__content">
                         <div className="sba-abu-dhabi-grid-section">
                              {leagueSummary.length !== 0 &&
                                   <UiSlider slidesToShow={1} infinite={true} dots={true}>
                                        {leagueSummary?.map(
                                             (item, idx) => (
                                                  <div>
                                                       <Grid
                                                            data={item.items}
                                                       >
                                                            <GridToolbar>
                                                                 <div className="sb-grid-incentive-top">
                                                                      <h4>Area 11 League</h4>
                                                                      <h5>PROVISIONAL</h5>
                                                                 </div>
                                                            </GridToolbar>
                                                            <GridColumn field="rank" title="Rank" width="80px" />
                                                            <GridColumn field="team" title="Team" width="280px" />
                                                            <GridColumn field="score" title="Score" width="80px" />
                                                       </Grid>
                                                  </div>
                                             ))}
                                   </UiSlider>                              
                              }

                         </div>
                    </div>
               </div>
          </div>
     );
}
